import Icon from 'shared/icons';

export interface INavList {
	name: string;
	header?: string;
	icon: JSX.Element;
	url: (cardinal?: number, mission?: number) => string;
	include: string;
	open: boolean;
	_onClick?: () => void;
}

export const nav_list: INavList[] = [
	{
		name: '대시보드',
		header: '크리에이터 프로그램 대시보드',
		icon: <Icon.DashboardOff />,
		url: (cardinal) => `/dashboard`,
		include: `/dashboard`,
		open: true,
	},
	{
		name: '크리에이터',
		header: '크리에이터 리포트',
		icon: <Icon.AccountCircleOff />,
		url: (cardinal) => `/creator`,
		include: `/creator`,
		open: true,
	},
	{
		name: '콘텐츠\n트래킹',
		header: '콘텐츠 트래킹',
		icon: <Icon.ExploreOff />,
		url: () => `/tracking`,
		include: `/tracking`,
		open: true,
	},
];
